import { jwtDecode } from "jwt-decode";

/**
 * Function validate token expired
 * @param token
 * @returns
 */
export const isTokenExpired = (token: any) => {
  if (!token) return true;

  try {
    const { exp } = jwtDecode(token);
    const now = Date.now() / 1000;
    return exp! < now;
  } catch (err) {
    return true;
  }
};
